import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';

dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezonePlugin);
dayjs().localeData();

export const formatDateWhen = (date: Date | string, timezone: string = 'Europe/Paris') => {
  const now = dayjs().tz(timezone).locale('fr');
  const dateObj = dayjs(date).tz(timezone).locale('fr');

  if (dateObj.isSame(now, 'day')) {
    return `aujourd'hui à ${dateObj.format('HH:mm')}`;
  } else {
    return `${dateObj.format('dddd D à HH:mm')}`;
  }
};

export const formatStartIn = (date: Date | string, timezone: string = 'Europe/Paris') => {
  const now = dayjs().tz(timezone);
  const dateObj = dayjs(date).tz(timezone);

  const diffMinutes = dateObj.diff(now, 'minute');

  if (diffMinutes < 60) {
    return `dans ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
  }

  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  if (minutes === 0) {
    return `dans ${hours} heure${hours > 1 ? 's' : ''}`;
  }

  return `dans ${hours} heure${hours > 1 ? 's' : ''} et ${minutes} minute${minutes > 1 ? 's' : ''}`;
};

export const formatNbHours = (nbHours: number): string => {
  if (nbHours === 0) return '0 heure';

  const days = Math.floor(nbHours / 24);
  const hours = nbHours % 24;

  const parts = [];

  if (days > 0) {
    parts.push(`${days} jour${days > 1 ? 's' : ''}`);
  }

  if (hours > 0) {
    parts.push(`${hours} heure${hours > 1 ? 's' : ''}`);
  }

  return parts.join(' et ');
};

export const getShouldAnswerBefore = (nbHours: number): Date => {
  let date = dayjs();
  let remaining = nbHours;

  while (remaining > 0) {
    date = date.add(1, 'hour');
    const day = date.day(); // 0 = Sunday, 6 = Saturday

    if (day !== 0 && day !== 6) {
      remaining--;
    }
  }

  return date.toDate();
};

export default dayjs;
